import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const stats = [
    { value: 5000, suffix: "+", label: "Candidates Registered" },
    { value: 300, suffix: "+", label: "Partner Companies" },
    { value: 25, suffix: "+", label: "Industries Served" },
    { value: 100, suffix: "%", label: "Commitment to Fair Hiring" },
];

const Counter = ({ value, suffix }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true });
    const [n, setN] = useState(0);

    useEffect(() => {
        if (!inView) return;
        let start = 0;
        const duration = 1600;
        const step = (ts) => {
            if (!start) start = ts;
            const p = Math.min((ts - start) / duration, 1);
            setN(Math.floor(p * value));
            if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
    }, [inView, value]);

    return (
        <span ref={ref}>
            {n.toLocaleString()}
            {suffix}
        </span>
    );
};

export const Stats = () => {
    return (
        <section data-testid="stats-section" className="relative py-20 px-5 sm:px-8 border-y border-white/10 bg-[#0A0F1C]">
            <div className="mx-auto max-w-7xl grid grid-cols-2 lg:grid-cols-4 gap-10">
                {stats.map((s, i) => (
                    <motion.div
                        key={s.label}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: i * 0.1 }}
                        data-testid={`stat-${i}`}
                        className="text-center lg:text-left"
                    >
                        <div className="font-display text-4xl sm:text-5xl font-extrabold text-[#F47B20]">
                            <Counter value={s.value} suffix={s.suffix} />
                        </div>
                        <p className="mt-2 text-sm text-slate-400">{s.label}</p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};
